module.exports = __webpack_public_path__ + "img/welding-11.0fd30176.jpg";